import { render, staticRenderFns } from "./connection-circuit-diagram.component.vue?vue&type=template&id=2b67f328"
import script from "./connection-circuit-diagram.component.ts?vue&type=script&lang=ts&external"
export * from "./connection-circuit-diagram.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b67f328')) {
      api.createRecord('2b67f328', component.options)
    } else {
      api.reload('2b67f328', component.options)
    }
    module.hot.accept("./connection-circuit-diagram.component.vue?vue&type=template&id=2b67f328", function () {
      api.rerender('2b67f328', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/diagram-view/connection-circuit-diagram/connection-circuit-diagram.component.vue"
export default component.exports